import "core-js/modules/es.array.reverse.js";
var _class, _WpsLoadableStratum, _class2, _descriptor, _WebProcessingServiceCatalogFunctionJob;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, isObservableArray, makeObservable, observable, override, runInAction, toJS } from "mobx";
import Mustache from "mustache";
import createGuid from "terriajs-cesium/Source/Core/createGuid";
import URI from "urijs";
import TerriaError from "../../../Core/TerriaError";
import isDefined from "../../../Core/isDefined";
import CatalogFunctionJobMixin from "../../../ModelMixins/CatalogFunctionJobMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import XmlRequestMixin from "../../../ModelMixins/XmlRequestMixin";
import xml2json from "../../../ThirdParty/xml2json";
import { ShortReportTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import { FeatureInfoTemplateTraits } from "../../../Traits/TraitsClasses/FeatureInfoTraits";
import WebProcessingServiceCatalogFunctionJobTraits from "../../../Traits/TraitsClasses/WebProcessingServiceCatalogFunctionJobTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import createStratumInstance from "../../Definition/createStratumInstance";
import updateModelFromJson from "../../Definition/updateModelFromJson";
import upsertModelFromJson from "../../Definition/upsertModelFromJson";
import GeoJsonCatalogItem from "../CatalogItems/GeoJsonCatalogItem";
import CatalogMemberFactory from "../CatalogMemberFactory";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
import executeWpsTemplate from "./ExecuteWpsTemplate.xml";
let WpsLoadableStratum = (_class = (_WpsLoadableStratum = class WpsLoadableStratum extends LoadableStratum(WebProcessingServiceCatalogFunctionJobTraits) {
  constructor(item) {
    super();
    this.item = item;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new WpsLoadableStratum(newModel);
  }
  static async load(item) {
    return new WpsLoadableStratum(item);
  }
  get shortReportSections() {
    const reports = this.item.outputs.map(output => {
      let report;
      if (isDefined(output.Data.LiteralData)) {
        report = createStratumInstance(ShortReportTraits, {
          name: output.Title,
          content: formatOutputValue(output.Title, output.Data.LiteralData)
        });
      }
      return report;
    }).filter(isDefined);
    return reports;
  }
  get featureInfoTemplate() {
    var _this$item$info$find;
    const template = ["#### Inputs\n\n" + ((_this$item$info$find = this.item.info.find(info => info.name === "Inputs")) === null || _this$item$info$find === void 0 ? void 0 : _this$item$info$find.content), "#### Outputs\n\n" + this.outputsSectionHtml].join("\n\n");
    return createStratumInstance(FeatureInfoTemplateTraits, {
      template
    });
  }
  get outputsSectionHtml() {
    const outputsSection = '<table class="cesium-infoBox-defaultTable">' + this.item.outputs.reduce((previousValue, output) => {
      if (!isDefined(output.Data) || !isDefined(output.Data.LiteralData) && !isDefined(output.Data.ComplexData)) {
        return previousValue;
      }
      let content = "";
      if (isDefined(output.Data.LiteralData)) {
        content = formatOutputValue(output.Title, output.Data.LiteralData);
      } else if (isDefined(output.Data.ComplexData)) {
        if (output.Data.ComplexData.mimeType === "text/csv") {
          content = '<chart can-download="true" hide-buttons="false" title="' + output.Title + "\" data='" + output.Data.ComplexData + '\' styling: "feature-info">';
        } else if (output.Data.ComplexData.mimeType === "application/vnd.terriajs.catalog-member+json") {
          content = "Chart " + output.Title + " generated.";
        }
        // Support other types of ComplexData here as it becomes necessary.
      }
      return previousValue + "<tr>" + '<td style="vertical-align: middle">' + output.Title + "</td>" + "<td>" + content + "</td>" + "</tr>";
    }, "") + "</table>";
    return outputsSection;
  }
  get rectangle() {
    var _this$item$geoJsonIte;
    return (_this$item$geoJsonIte = this.item.geoJsonItem) === null || _this$item$geoJsonIte === void 0 ? void 0 : _this$item$geoJsonIte.rectangle;
  }
}, _defineProperty(_WpsLoadableStratum, "stratumName", "wpsLoadable"), _WpsLoadableStratum), _applyDecoratedDescriptor(_class, "load", [action], Object.getOwnPropertyDescriptor(_class, "load"), _class), _applyDecoratedDescriptor(_class.prototype, "shortReportSections", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shortReportSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "featureInfoTemplate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "featureInfoTemplate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "outputsSectionHtml", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "outputsSectionHtml"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rectangle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rectangle"), _class.prototype), _class);
StratumOrder.addLoadStratum(WpsLoadableStratum.stratumName);
let WebProcessingServiceCatalogFunctionJob = (_class2 = (_WebProcessingServiceCatalogFunctionJob = class WebProcessingServiceCatalogFunctionJob extends XmlRequestMixin(CatalogFunctionJobMixin(CreateModel(WebProcessingServiceCatalogFunctionJobTraits))) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "proxyCacheDuration", "1d");
    _initializerDefineProperty(this, "geoJsonItem", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return WebProcessingServiceCatalogFunctionJob.type;
  }
  get typeName() {
    return i18next.t("models.webProcessingService.wpsResult");
  }
  get executeUrlParameters() {
    return {
      service: "WPS",
      request: "Execute",
      version: "1.0.0"
    };
  }

  /**
   * Returns the proxied URL for the Execute endpoint.
   */
  get executeUrl() {
    if (!isDefined(this.url)) {
      return;
    }
    const uri = new URI(this.url).query(this.executeUrlParameters);
    return proxyCatalogItemUrl(this, uri.toString(), this.proxyCacheDuration);
  }
  async _invoke() {
    if (!isDefined(this.identifier) || !isDefined(this.executeUrl) || !isDefined(this.wpsParameters)) {
      throw "Identifier, executeUrl and wpsParameters must be set";
    }
    const identifier = this.identifier;
    const executeUrl = this.executeUrl;
    const parameters = _objectSpread(_objectSpread({}, this.executeUrlParameters), {}, {
      Identifier: htmlEscapeText(identifier),
      DataInputs: toJS(this.wpsParameters),
      storeExecuteResponse: toJS(this.storeSupported),
      status: toJS(this.statusSupported)
    });
    let promise;
    if (this.executeWithHttpGet) {
      promise = this.getXml(executeUrl, _objectSpread(_objectSpread({}, parameters), {}, {
        DataInputs: parameters.DataInputs.map(_ref => {
          let {
            inputIdentifier: id,
            inputValue: val
          } = _ref;
          return "".concat(id, "=").concat(val);
        }).join(";")
      }));
    } else {
      const executeXml = Mustache.render(executeWpsTemplate, parameters);
      promise = this.postXml(executeUrl, executeXml);
    }
    const executeResponseXml = await promise;
    if (!executeResponseXml || !executeResponseXml.documentElement || executeResponseXml.documentElement.localName !== "ExecuteResponse") {
      throw "Invalid XML response for WPS ExecuteResponse";
    }
    const json = xml2json(executeResponseXml);

    // Check if finished
    if (this.checkStatus(json)) {
      // set result
      runInAction(() => this.setTrait(CommonStrata.user, "wpsResponse", json));
      return true;
    }

    // If not finished, set response URL for polling
    runInAction(() => this.setTrait(CommonStrata.user, "wpsResponseUrl", json.statusLocation));
    return false;
  }

  /**
   * Return true for finished, false for running, throw error otherwise
   */
  checkStatus(json) {
    const status = json.Status;
    if (!isDefined(status)) {
      throw new TerriaError({
        sender: this,
        title: i18next.t("models.webProcessingService.invalidResponseErrorTitle"),
        message: i18next.t("models.webProcessingService.invalidResponseErrorMessage", {
          name: this.name
        })
      });
    }
    if (isDefined(status.ProcessFailed)) {
      var _status$ProcessFailed;
      throw ((_status$ProcessFailed = status.ProcessFailed.ExceptionReport) === null || _status$ProcessFailed === void 0 || (_status$ProcessFailed = _status$ProcessFailed.Exception) === null || _status$ProcessFailed === void 0 ? void 0 : _status$ProcessFailed.ExceptionText) || JSON.stringify(status.ProcessFailed);
    } else if (isDefined(status.ProcessSucceeded)) {
      return true;
    }
    return false;
  }
  async pollForResults() {
    if (!isDefined(this.wpsResponseUrl)) {
      return true;
    }
    const promise = this.getXml(proxyCatalogItemUrl(this, this.wpsResponseUrl, "0d"));
    const xml = await promise;
    const json = xml2json(xml);
    return this.checkStatus(json);
  }
  async downloadResults() {
    if (isDefined(this.wpsResponseUrl) && !isDefined(this.wpsResponse)) {
      const url = proxyCatalogItemUrl(this, this.wpsResponseUrl, "0d");
      const wpsResponse = xml2json(await this.getXml(url));
      runInAction(() => {
        this.setTrait(CommonStrata.user, "wpsResponse", wpsResponse);
      });
    }
    if (!isDefined(this.wpsResponse)) return;
    const reports = [];
    const outputs = runInAction(() => this.outputs);
    const results = [];
    await Promise.all(outputs.map(async (output, i) => {
      if (!output.Data.ComplexData) {
        return;
      }
      let reportContent = output.Data.ComplexData;
      if (output.Data.ComplexData.mimeType === "text/csv") {
        reportContent = '<collapsible title="' + output.Title + '" open="' + (i === 0 ? "true" : "false") + '">';
        reportContent += '<chart can-download="true" hide-buttons="false" title="' + output.Title + "\" data='" + output.Data.ComplexData.text + '\' styling="histogram"></chart>';
        reportContent += "</collapsible>";
      } else if (output.Data.ComplexData.mimeType === "application/vnd.terriajs.catalog-member+json") {
        // Create a catalog member from the embedded json
        const json = JSON.parse(output.Data.ComplexData.text);
        const catalogItem = await this.createCatalogItemFromJson(json);
        if (isDefined(catalogItem)) {
          if (CatalogMemberMixin.isMixedInto(catalogItem)) results.push(catalogItem);
          reportContent = "Chart " + output.Title + " generated.";
        }
      }
      reports.push(createStratumInstance(ShortReportTraits, {
        name: output.Title,
        content: reportContent
      }));
    }));

    // Create geojson catalog item for input features
    const geojsonFeatures = runInAction(() => this.geojsonFeatures);
    if (Array.isArray(geojsonFeatures) || isObservableArray(geojsonFeatures)) {
      runInAction(() => {
        this.geoJsonItem = new GeoJsonCatalogItem(createGuid(), this.terria);
        updateModelFromJson(this.geoJsonItem, CommonStrata.user, {
          name: "".concat(this.name, " Input Features"),
          // Use cesium primitives, so we don't have to deal with feature picking/selection
          forceCesiumPrimitives: true,
          geoJsonData: {
            type: "FeatureCollection",
            features: geojsonFeatures,
            totalFeatures: this.geojsonFeatures.length
          }
        }).logError("Error occurred while updating Input Features GeoJSON model JSON");
      });
      (await this.geoJsonItem.loadMapItems()).throwIfError();
    }
    runInAction(() => {
      this.setTrait(CommonStrata.user, "shortReportSections", reports);
    });
    return results;
  }
  get mapItems() {
    if (isDefined(this.geoJsonItem)) {
      return this.geoJsonItem.mapItems.map(mapItem => {
        mapItem.show = this.show;
        return mapItem;
      });
    }
    return [];
  }
  async forceLoadMetadata() {
    await super.forceLoadMetadata();
    const stratum = await WpsLoadableStratum.load(this);
    runInAction(() => {
      this.strata.set(WpsLoadableStratum.stratumName, stratum);
    });
  }
  async forceLoadMapItems() {
    if (isDefined(this.geoJsonItem)) {
      const geoJsonItem = this.geoJsonItem;
      (await geoJsonItem.loadMapItems()).throwIfError();
    }
  }

  /**
   * Returns all the process outputs skipping process contexts and empty outputs
   */
  get outputs() {
    const wpsResponse = this.wpsResponse;
    if (!wpsResponse || !wpsResponse.ProcessOutputs || !wpsResponse.ProcessOutputs.Output) {
      return [];
    }
    const obj = wpsResponse.ProcessOutputs.Output;
    const outputs = Array.isArray(obj) || isObservableArray(obj) ? obj : [obj];
    return outputs.filter(o => o.Identifier !== ".context" && isDefined(o.Data));
  }
  async createCatalogItemFromJson(json) {
    let itemJson = json;
    if (this.forceConvertResultsToV8 ||
    // If startData.version has version 0.x.x - user catalog-converter to convert result
    "version" in itemJson && typeof itemJson.version === "string" && itemJson.version.startsWith("0")) {
      itemJson = await convertResultV7toV8(json).catch(e => {
        throw e;
      });
    }
    const catalogItem = upsertModelFromJson(CatalogMemberFactory, this.terria, this.uniqueId || "", CommonStrata.user, _objectSpread(_objectSpread({}, itemJson), {}, {
      id: createGuid()
    }), {
      addModelToTerria: false
    }).throwIfError({
      title: "WPS output error",
      message: "Failed to create Terria model from WPS output".concat(itemJson.name ? ": ".concat(itemJson.name) : "")
    });
    return catalogItem;
  }
}, _defineProperty(_WebProcessingServiceCatalogFunctionJob, "type", "wps-result"), _WebProcessingServiceCatalogFunctionJob), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "geoJsonItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "executeUrl", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "executeUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "checkStatus", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "checkStatus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mapItems", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "mapItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "outputs", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "outputs"), _class2.prototype), _class2);
export { WebProcessingServiceCatalogFunctionJob as default };
function formatOutputValue(title, value) {
  if (!isDefined(value)) {
    return "";
  }
  const values = value.split(",");
  return values.reduce(function (previousValue, currentValue) {
    if (value.match(/[./](png|jpg|jpeg|gif|svg)/i)) {
      return previousValue + '<a href="' + currentValue + '"><img src="' + currentValue + '" alt="' + title + '" /></a>';
    } else if (currentValue.indexOf("http:") === 0 || currentValue.indexOf("https:") === 0) {
      const uri = new URI(currentValue);
      return previousValue + '<a href="' + currentValue + '">' + uri.filename() + "</a>";
    } else {
      return previousValue + currentValue;
    }
  }, "");
}
async function convertResultV7toV8(input) {
  const {
    convertMember,
    convertCatalog
  } = await import("catalog-converter");
  if (typeof input.type === "string") {
    const {
      member,
      messages
    } = convertMember(input);
    if (member === null) throw TerriaError.combine(messages.map(m => TerriaError.from(m.message)), "Error converting v7 item to v8");
    return member;
  } else {
    const {
      result,
      messages
    } = convertCatalog(input);
    if (result === null) throw TerriaError.combine(messages.map(m => TerriaError.from(m.message)), "Error converting v7 catalog to v8");
    return result;
  }
}
function htmlEscapeText(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}